<template>
  <div>
    <div class="overflow-x-auto" :class="{ 'mb-12': !hasResults }">
      <table id="i-table" class="w-full text-sm text-left text-gray-500">
        <thead class="text-xs text-gray-700 uppercase bg-gray-50">
          <tr>
            <th v-for="(label, index) in labels" :key="label" scope="col" class="py-3 px-6 text-center t-th" :class="`t-${categories[index]}`">
              {{ label }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr class="bg-white border-b">
            <td v-for="(item, index) in data" :key="`${index}-${data.indexOf(item)}`" class="py-4 px-6 text-center t-td" :class="`t-${categories[index]}`">
              {{ item }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="hasResults" id="i-table-foot" class="bg-white border-t mb-12 flex">
      <button class="btn-indigo my-4 mx-auto" type="button" @click="exportTable">
        Exportar para XLSX
      </button>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx'

export default {
  props: {
    results: Object,
  },
  data() {
    return {
      $this: this,
      get labels() {
        return this.$this.getFromResults('labels')
      },
      get data() {
        return this.$this.getFromResults('data')
      },
      get categories() {
        return this.$this.getFromResults('categories')
      },
      get order() {
        return this.$this.getFromResults('_order')
      },
      get hasResults() {
        return Object.keys(this.$this.results?.data ?? {}).length > 1
      },
    }
  },
  methods: {
    getFromResults(get) {
      if (!this.results || !this.results[get]) {
        return []
      }

      if (get === '_order') {
        return this.results[get]
      }

      const itens = []

      this.order.forEach(id => {
        itens.push(this.results[get][id])
      })

      return itens
    },
    isInTable(label) {
      let is = false

      this.labels.forEach((l, index) => {
        if (l == label) {
          is = index
        }
      })

      return is
    },
    exportTable() {
      const workBook = XLSX.utils.table_to_book(
        document.getElementById('i-table'),
        { sheet: 'Indicadores' },
      )

      return XLSX.writeFile(workBook, `indicadores.${Date.now()}.xlsx`)
    },
  },
}
</script>
